import { render, staticRenderFns } from "./ProductRanges.vue?vue&type=template&id=38669c32&scoped=true&"
import script from "./ProductRanges.vue?vue&type=script&lang=ts&"
export * from "./ProductRanges.vue?vue&type=script&lang=ts&"
import style0 from "./ProductRanges.vue?vue&type=style&index=0&id=38669c32&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38669c32",
  null
  
)

export default component.exports